import { render, staticRenderFns } from "./message-center.vue?vue&type=template&id=5303cb23&scoped=true"
import script from "./message-center.ts?vue&type=script&lang=ts&external"
export * from "./message-center.ts?vue&type=script&lang=ts&external"
import style0 from "./message-center.scoped.scss?vue&type=style&index=0&id=5303cb23&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5303cb23",
  null
  
)

export default component.exports